import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { adminChangePartnerApprovalStatus,  approveOrRejectRentalVehicleStatusApi,createOrUpdateRentalVehicleDetailsApi,createOrUpdateVehicleDetailsApi,editRentalVendorApi, getVehicleCategoryListApi, rentalvendorDetailsById, savePartnerBankDetailsApi, updateDriverDocsApi, updatePartnerProfileApi, uploadFileApi } from '../../../utils/ApiEndpointFunctions';
import Spinwheel from '../../common/Spinwheel';
import { capitalizeWords, convertTo12HourFormat, dateFormat } from '../../../utils/HelperFuncitons';
import SelectedUserDetail from '../../common/SelectedUserDetail';
import { S3_URL } from '../../../utils/BaseUrl';
import ConfirmationModal from '../../common/ConfirmationModal';
import PdfSvgIcon from '../../common/PdfSvgIcon';
import ImageViewModal from '../../common/Modal/ImageViewModal';
import toast from 'react-hot-toast';
import moment from 'moment';
import CommonTable from '../../common/Table/CommonTable';
import ThreeDotsIcon from '../../common/ThreeDotsIcon';
import { useFormik } from 'formik';
import { bankDetailsInitialValue, bankDetailsValidationSchema, profileDetailsInitialValue, profileValidationSchema, rateInitialValues, rateValidationSchema, rentalVehicleInitialValue, rentalVehicleValidationSchema, vehicleInitialValue, vehicleValidationSchema } from '../../common/Validation';
import { useAdminContext } from '../../../context/adminContext';
import PartnerReviewTable from '../../common/PartnerReviewTable';
import AddOrUpdateDetails from '../../common/Modal/AddOrUpdateDetails';
import { values } from 'lodash';






const RentalVendorDetails = (props) => {
    const params = useParams();
    const [id, setId] = useState(params?.id)
    const [rentalVendorDetails, setRentalVendorDetails] = useState({});
    const [vehicleDetails, setVehicleDetails] = useState([]);
    const [bankDetails, setBankDetails] = useState([]);
    const [loader, setLoader] = useState(true);
    const [rateLoader, setRateLoader] = useState(false);
    const [activeTab, setActiveTab] = useState('driver');
    const [confirmStatus, setConfirmStatus] = useState({ status: "", userId: "", role: "hire" });
    const [selectedImg, setSelectedImg] = useState("")
    const confirmationModalId2 = "confirmationModal2"
    const [keyNameForUpdate, setKeyNameForUpdate] = useState("")
    const [selectVehicle, setSelectVehicle] = useState({});
    const { adminDetail } = useAdminContext();
    const driverBankModal2 = "driverBankModal2"
    const [detailsType,setDetailsType] = useState({type:"",loading:false})
    const [fileUpload,setFileUpload] = useState([])
     const [vehicleCategoryList,setVehicleCategoryList] = useState({list:[],categoryId:"",modelId:"",makeId:""})

    const fetchDriverDetails = async () => {
        try {

            const res = await rentalvendorDetailsById(id);
            if (res.status === 200) {
                const { vehicles, details } = res.data.data;

                const { id, role, phone, rentalVendor,referralCode, bankDetails, partnerUserDetails } = details
                setRentalVendorDetails({ id,referralCode, phone, role, ...partnerUserDetails[0], vendorStatus: rentalVendor?.status });
                rateFormik.setValues({id : id, commissionFee: rentalVendor.commissionFee, discount: rentalVendor.discount})
                setVehicleDetails(vehicles);
                setBankDetails(bankDetails)

            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    useEffect(()=>{
        console.log("fprmik vall",driverDetailsFormik.values)
        console.log("just check",vehicleCategoryList?.list.map(item => ({ makeid: item.makeid, make: item.make })));
    },[])
    

     const fetchVehicleCategory = async (category="", make="", model="") => {
            try {
                const res = await getVehicleCategoryListApi(id,category,make,model);
                if (res.status === 200) {
                    setVehicleCategoryList({...vehicleCategoryList,list:res.data?.data?.categoryList});
                }
            } catch (error) {
                console.log(error);
            }
        };

        useEffect(()=>{
            fetchVehicleCategory()
        },[])

    const genderOptions = [
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
        { label: "Other", value: "other" },

    ]
  
    useEffect(() => {
        console.log("formik",driverDetailsFormik.values)
        }, [vehicleDetails,vehicleCategoryList?.list,selectVehicle]);
          


    async function handleFileUpload(name, e, formik) {
        try {
            const file = e.target.files[0];
            if (file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("type", "documents")
                setFileUpload([...fileUpload, name])
                const res = await uploadFileApi(formData)
                formik.setFieldTouched(name, true)
                if (res.status === 200 && res.data?.status === 1) {
                    formik.setFieldValue(name, res.data?.data);
                    toast.success("File uploaded");
                }
            }
        } catch (error) {
            formik.setFieldTouched(`image`, true)
            console.log(error)
            if (error?.response === undefined) {
                toast.error("File size is too large")
            }
        }
        setFileUpload([...fileUpload?.filter(ele => ele != name)])
    }

    const handleChangeStatus = async () => {
        try {
            setLoader(true)
            await adminChangePartnerApprovalStatus(confirmStatus)
            fetchDriverDetails();
            document.getElementById('confirmationModal').click()
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
            setLoader(false)
        }
    }

    const openModal = () => {
        document.getElementById('confirmationModal2Btn').click()
    }

    useEffect(() => {
        if (id) {
            fetchDriverDetails();
        }
        
    }, [id]);

    const toggleTab = (tab) => {
        setActiveTab(tab);
    };

    const handleChangeDocumentStatus = async (status, keyName) => {
        const promise = approveOrRejectRentalVehicleStatusApi({ userId: id, keyName: keyName, status: status, rentalVehicleId: selectVehicle.id });
        toast.promise(
            promise,
            {
                loading: 'Updating document status...',
                success: (res) => {
                    if (res.status === 200) {
                        vehicleDetails.filter(ele => ele.id === selectVehicle.id)[0][keyName] = res.data.docStatus
                        setSelectVehicle({ ...selectVehicle, [keyName]: res.data.docStatus })
                        if (res.data.rentalVechileStatus) setRentalVendorDetails({ ...rentalVendorDetails, vendorStatus: res.data.rentalVechileStatus })
                        return res.data.message || 'Success';
                    }
                },
                error: (err) => {
                    return err.message || 'Something Went Wrong'
                }
            }
        )
    };

    const DocumentDisplay = ({ title, document, setSelectedImg, status, keyName, validUpto }) => {
        if (!document) {
            return (
                <tr>
                    <td>{title}</td>
                    <td className='text-center'>{`${title} not available`}</td>
                </tr>
            );
        }

        const isPdf = document ? Array.isArray(document) ? document[0]?.split(".").slice(-1)[0] === "pdf" : document.split(".").slice(-1)[0] === "pdf" : "";

        return (
            <tr>
                <td>{title}</td>
                <td className='text-center'>
                    {isPdf ? (
                        <Link to={`${S3_URL}/${document}`} className="text-primary">
                            <PdfSvgIcon width="100" height="100" />
                        </Link>
                    ) : (Boolean(Array.isArray(document) ? document.length : document) ?
                        <div
                            onClick={() => setSelectedImg(Array.isArray(document) ? document : `${S3_URL}/${document}`)}
                            data-bs-toggle="modal"
                            data-bs-target={`#imageViewModal`}
                            style={{ cursor: 'pointer' }}
                        >
                            <img
                                src={`${S3_URL}/${Array.isArray(document) ? document[0] : document}`}
                                alt={title}
                                data-bs-toggle="modal"
                                data-bs-target={`#imageViewModal`}
                                style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
                                onClick={() => setSelectedImg(Array.isArray(document) ? document : `${S3_URL}/${document}`)}
                            />
                            <div className='text-primary fs-5'>{(Boolean(Array.isArray(document)) && (document.length > 1)) && `View more`}</div>
                        </div>
                    : "File not found")}
                </td>
                <td className='text-center'>{validUpto ? dateFormat(validUpto) : ""}</td>
                <td className='text-center'>{capitalizeWords(status) || "-"}</td>
                {status !== "pending" && <td className='text-center'>
                    <div className="dropdown">
                        <button
                            className=" border-0 bg-white"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <ThreeDotsIcon />
                        </button>
                        <ul
                            className="dropdown-menu"
                            style={{ zIndex: "1000" }}
                        >
                            {(status === "rejected" || status === "submitted") && <li
                                onClick={() => {
                                    if (moment().toISOString() < moment(validUpto).toISOString()) {
                                        handleChangeDocumentStatus('approved', keyName)
                                    } else {
                                        setKeyNameForUpdate(keyName)
                                        openModal()
                                    }
                                }}
                            >
                                <a className="dropdown-item" href="#">
                                    Approve
                                </a>
                            </li>}

                            {(status === "approved" || status === "submitted") && <li
                                onClick={() =>
                                    handleChangeDocumentStatus('rejected', keyName)
                                }
                            >
                                <a className="dropdown-item" href="#">
                                    Reject
                                </a>
                            </li>}
                        </ul>
                    </div>
                </td>}
            </tr>
        );
    };



    const vehicleHeaderData = [
        { name: "Year", className: "list-sort text-muted", key: "year" },
        { name: "Class", className: "list-sort text-muted", key: "category" },
        { name: "Type", className: "list-sort text-muted", key: "make" },
        { name: "Model", className: "list-sort text-muted", key: "model" },
        { name: "Color", className: "list-sort text-muted", key: "color" },
        { name: "Registration Number", className: "list-sort text-muted", key: "vehicleNumber" },
        { name: "Documents", className: "list-sort text-muted", key: "action" },
    ]

    const vehicleTableData = vehicleDetails.map((vhcl, index) => {
        return {
            licenseNo: vhcl.licenseNo,
            year: vhcl.year,
            category: vhcl?.category,
            make: vhcl?.make,
            model: vhcl?.model,
            color: capitalizeWords(vhcl?.color) || "",
            vehicleNumber: vhcl?.vehicleNumber || "",
            vehicleCertificate: vhcl?.vehicleCertificate?.split(".")?.slice(-1)?.includes("pdf") ?
                <Link to={`${S3_URL}/${vhcl?.vehicleCertificate}`}  > <PdfSvgIcon width="100" height="100" /></Link>
                :
                <img
                    src={vhcl?.vehicleCertificate ? `${S3_URL}/${vhcl?.vehicleCertificate}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg"}
                    alt={"img"}
                    data-bs-toggle="modal"
                    data-bs-target={`#imageViewModal`}
                    style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
                    onClick={() => { setSelectedImg(vhcl?.vehicleCertificate ? `${S3_URL}/${vhcl?.vehicleCertificate}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg") }}
                />,
            vehicleInsurance: vhcl?.vehicleInsurance?.split(".")?.slice(-1)?.includes("pdf") ?
                <Link to={`${S3_URL}/${vhcl?.vehicleInsurance}`}> <PdfSvgIcon width="100" height="100" /></Link>
                :
                <img
                    src={vhcl?.vehicleInsurance ? `${S3_URL}/${vhcl?.vehicleInsurance}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg"}
                    alt={"img"}
                    data-bs-toggle="modal"
                    data-bs-target={`#imageViewModal`}
                    style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
                    onClick={() => { setSelectedImg(vhcl?.vehicleInsurance ? `${S3_URL}/${vhcl?.vehicleInsurance}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg") }}
                />,
            action: (
            // <div style={{ cursor: "pointer" }} className='text-primary' data-bs-toggle="offcanvas" data-bs-target="#offcanvasRightCites" onClick={() => { setSelectVehicle(vhcl) }}>View</div>
            <div className="dropdown">
                                    <button
                                        className=" border-0 bg-white"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-three-dots-vertical"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                        </svg>
                                    </button>
                                    <ul className="dropdown-menu"
                                        style={{ zIndex: 1000 }}
                                    >
                                         <li>
                                         <a style={{ cursor: "pointer" }} className='dropdown-item text-primary' data-bs-toggle="offcanvas" data-bs-target="#offcanvasRightCites" onClick={() => { setSelectVehicle(vhcl) }}>View</a>
                                         </li>
                                         <li data-bs-toggle="modal" data-bs-target={`#${driverBankModal2}`} onClick={() => { 
                           const matchedCategory = vehicleCategoryList?.list?.find(
                            (cat) => cat.category === vhcl.category
                          );
                          const matchedModel = vehicleCategoryList?.list?.find(
                            (mdl) => mdl.model === vhcl.model
                          );
                          const matchedMake = vehicleCategoryList?.list?.find(
                            (mk) => mk.make === vhcl.make
                          );
                        
                          driverDetailsFormik.setValues({
                            ...vhcl,
                            categoryId: matchedCategory
                              ? { label: matchedCategory.category, value: matchedCategory.id }
                              : { label: "", value: "" },
                            modelId: matchedModel
                              ? { label: matchedModel.model, value: matchedModel.modelId }
                              : { label: "", value: "" },
                            makeId: matchedMake
                              ? { label: matchedMake.make, value: matchedMake.makeid }
                              : { label: "", value: "" },
                                });
                                setActiveTab("vehicle") }}>
                            <a className="dropdown-item" href="#">
                                Edit
                            </a>
                        </li>

                                    </ul>
                                </div>
        )
        }
    })


    const bankDetailsHeaderData = [
        { name: "Account Holder Namer", className: "list-sort text-muted", key: "name" },
        { name: "Bank Name", className: "list-sort text-muted", key: "bankName" },
        { name: "IFSC", className: "list-sort text-muted", key: "Ifsc" },
        { name: "Account Number", className: "list-sort text-muted", key: "accountNo" },
        { name: "Account Type", className: "list-sort text-muted", key: "accountType" },
        { name: <div className='d-flex gap-2 justify-content-center align-items-center'><div>Action</div><div>{!bankDetails?.length && <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Add</button>}</div></div>, className: "col-1", key: "action" },
    ]

    const bankDetailsTableData = bankDetails?.map((bnk, index) => ({
        name: rentalVendorDetails.name || "",
        bankName: bnk.bankName || "",
        Ifsc: bnk.Ifsc || "",
        accountNo: bnk.accountNo || "",
        accountType: bnk.accountType || "",
        action: (
            // <span
            //   style={{ cursor: "pointer" }}
            //   data-bs-toggle="modal"
            //   data-bs-target={`#${driverBankModal2}`}
            //   onClick={() => {
            //     driverDetailsFormik?.setValues({
            //       ...bnk,
            //       name: {
            //         label: rentalVendorDetails?.name,
            //         value: rentalVendorDetails?.name,
            //       },
            //     });
            //     setActiveTab("bankDetails");
            //   }}
            // >
            //   Edit
            // </span>
            <div className="dropdown">
              <button
                className=" border-0 bg-white"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-three-dots-vertical"
                  viewBox="0 0 16 16">
                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                </svg>
              </button>
              <ul
                className="dropdown-menu"
                style={{ zIndex: "1000" }}>
                <li
                  data-bs-toggle="modal"
              data-bs-target={`#${driverBankModal2}`}
              onClick={() => {
                driverDetailsFormik?.setValues({
                  ...bnk,
                  name: {
                    label: rentalVendorDetails?.name,
                    value: rentalVendorDetails?.name,
                  },
                });
                setActiveTab("bankDetails");
              }}
                 >
                  <a className="dropdown-item" href="#">
                    Edit
                  </a>
                </li>
              </ul>
            </div>
          ),
      }));
      
      console.log("bankDetail",bankDetails)

    const profileData = [
        { name: "Email", data: rentalVendorDetails.email, },
        { name: "Phone", data: rentalVendorDetails.phone, },
        { name: "Alternate Phone", data: rentalVendorDetails.alternateMobile, },
        { name: "NIN", data: rentalVendorDetails.NIN, },
        { name: "Status", data: capitalizeWords(rentalVendorDetails.vendorStatus), },
        { name: "Role", data: rentalVendorDetails.role?.map(el => capitalizeWords(el))?.join(", "), },
        { name: "Gender", data: rentalVendorDetails.gender, },
        { name: "City", data: rentalVendorDetails.city, },
        { name: "State", data: rentalVendorDetails.state, },
        { name: "Country", data: rentalVendorDetails.country, },
        { name: "Zip Code", data: rentalVendorDetails.zip, },
        { name: "Address", data: <div>{rentalVendorDetails.permanentAddress && `${rentalVendorDetails.permanentAddress}, `}{rentalVendorDetails.state && `${rentalVendorDetails.state}, `}{rentalVendorDetails.city && `${rentalVendorDetails.city}, `}{rentalVendorDetails.zip && `${rentalVendorDetails.zip}`}</div>, },
        { name: "Referral Code", data: rentalVendorDetails.referralCode, },
    ]

    useEffect(()=>{
     console.log("rental vendor",rentalVendorDetails)
    },[rentalVendorDetails])

    const rateSubmit = async (values) => {
        setRateLoader(true)
        try {
            const res = await editRentalVendorApi(values)
            if(res.status === 200) {

                toast.success(res.data.message)
            }        
        } catch (error) {
            toast.error("Failed to update rate")

        }

        setRateLoader(false)

        console.log(values)
    }

    const rateFormik = useFormik({
        initialValues: rateInitialValues,
        validationSchema: rateValidationSchema,
        onSubmit: rateSubmit
    })

    function handleInputChange(name, e, formik, input, type) {
        if (input == "input") {
            const { value } = e?.target
            if (type == "number" && isNaN(value)) return
            formik.setFieldValue(name, value)
        } else if (input == "date") {
            formik.setFieldValue(name, e)
        } else if (input == "select") {
            let list = [{ name, value: e }]
            if (name == "categoryId") {
                list.push({ name: "modelId", value: "" }, { name: "makeId", value: "" })
            } else if (name == "modelId") {
                list.push({ name: "makeId", value: "" })
            }

            list?.forEach(ele => {
                formik.setFieldValue(ele?.name, ele?.value)
            })
        } else if (input == "address") {
            formik.setFieldValue(name, e?.label)
        }

    }

    async function handleDriverDetailSubmit(payload, apiEndPoint) {
        try {
            console.log("in try block")
            setDetailsType({ ...detailsType, loading: true })
            const res = await apiEndPoint({ ...payload, partnerUserId: id })
            if (res?.status == 200 || res?.status == 201) {
                fetchDriverDetails();
                document.getElementById(detailsFields[activeTab]?.modalId)?.click()
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
        }
        setDetailsType({ ...detailsType, loading: false })
    }

    const detailsFields = {
        "bankDetails": {
            format: [
                { name: "bankName", label: "Bank Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "accountNo", label: "Account No", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                { name: "accountType", label: "Account Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "Ifsc", label: "IFSC", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                
            ],
            initialvalue: bankDetailsInitialValue,
            validationSchema: bankDetailsValidationSchema,
            handleSubmit: (values) => handleDriverDetailSubmit(values, savePartnerBankDetailsApi),
            modalId: driverBankModal2
        },
        "vehicle": {
            format: [
                { name: "categoryId", label: "Class", type: "select", options: vehicleCategoryList?.list?.filter((el, ind) => ind == vehicleCategoryList?.list.indexOf(vehicleCategoryList?.list?.filter((li, indx) => li?.id == el?.id)?.[0]))?.map(ele => { return { label: ele?.category, value: ele?.id } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "modelId", label: "Modal", type: "select", options: vehicleCategoryList?.list?.filter((el, ind) => ind == vehicleCategoryList?.list.indexOf(vehicleCategoryList?.list?.filter((li, indx) => li?.modelId == el?.modelId)?.[0]))?.map(ele => { return { label: ele?.model, value: ele?.modelId } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "makeId", label: "Type", type: "select", options: vehicleCategoryList?.list?.map(ele => { return { label: ele?.make, value: ele?.makeid } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                // { name: "makeId", label: "Type", type: "select", handleOnChange: (...values) => handleInputChange(...values, "select") },
                { name: "year", label: "Year", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                { name: "color", label: "Color", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                // { name: "licenseNo", label: "License number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "vehicleNumber", label: "Vehicle number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
            ],
            initialvalue: rentalVehicleInitialValue,
            validationSchema: rentalVehicleValidationSchema,
            handleSubmit: (values) => { 
                console.log("Submitting values", values);
                handleDriverDetailSubmit({ ...values, categoryId: values?.categoryId?.value, makeId: values?.makeId?.value, modelId: values?.modelId?.value }, createOrUpdateRentalVehicleDetailsApi)
            },
            modalId: driverBankModal2
        },
        "driver": {
            format: [
                { name: "categoryId", label: "Class", type: "select", options: vehicleCategoryList?.list?.filter((el, ind) => ind == vehicleCategoryList?.list.indexOf(vehicleCategoryList?.list?.filter((li, indx) => li?.id == el?.id)?.[0]))?.map(ele => { return { label: ele?.category, value: ele?.id } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "modelId", label: "Modal", type: "select", options: vehicleCategoryList?.list?.filter((el, ind) => ind == vehicleCategoryList?.list.indexOf(vehicleCategoryList?.list?.filter((li, indx) => li?.modelId == el?.modelId)?.[0]))?.map(ele => { return { label: ele?.model, value: ele?.modelId } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                {
                    name: "makeId",
                    label: "Type",
                    type: "select",
                    options: vehicleCategoryList?.list
                      ?.filter((makeItem, makeIndex, fullList) =>
                        fullList.findIndex(item => item.make?.toLowerCase() === makeItem.make?.toLowerCase()) === makeIndex
                      )
                      ?.map(makeItem => ({
                        label: makeItem.make,
                        value: makeItem.makeid
                      })),
                    handleOnChange: (...values) => handleInputChange(...values, "text")
                  }
                  ,
                  {
                    name: "year",
                    label: "Year",
                    type: "input",
                    handleOnChange: (...values) => handleInputChange(...values, "number"),
                  },
                  {
                    name: "color",
                    label: "Color",
                    type: "input",
                    handleOnChange: (...values) => handleInputChange(...values, "text"),
                  },
                  {
                    name: "vehicleNumber",
                    label: "Vehicle number",
                    type: "input",
                    handleOnChange: (...values) => handleInputChange(...values, "text"),
                  },
            ],
            initialvalue: profileDetailsInitialValue,
            validationSchema: profileValidationSchema,
            handleSubmit: (values) => {
                console.log("Submitting values", values);
                handleDriverDetailSubmit({ ...values, gender: values?.gender?.value },
                updatePartnerProfileApi)},
            modalId: driverBankModal2
        },
        
    }

    const driverDetailsFormik = useFormik({
        initialValues:detailsFields?.[activeTab]?.initialvalue,
        validationSchema:detailsFields?.[activeTab]?.validationSchema,
        enableReinitialize:true,
        onSubmit:detailsFields?.[activeTab]?.handleSubmit
    })

    // console.log(driverDetailsFormik.errors, detailsFields?.[activeTab])

    const tabData = [
        {
            name: "Profile Details", tab: "driver", setTab: toggleTab, data: <div className="row card">
                <div className="row mt-3">
                    <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary' onClick={() => driverDetailsFormik.setValues({ ...rentalVendorDetails, gender: { label: capitalizeWords(rentalVendorDetails?.gender), value: rentalVendorDetails?.gender } })} data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Edit</button>
                    </div>
                    <div className="user-details">
                        <table className="table table-md table-hover card-table">
                            <tbody>
                                {
                                    profileData.map((ele, index) => (
                                        <tr key={index}>
                                            <td>{ele.name}:</td>
                                            <td>{ele.data}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        },
        { name: "Vehicle Details", tab: "vehicle", setTab: toggleTab, data: <div className='p-3 card'><CommonTable headers={vehicleHeaderData} data={vehicleTableData} /> </div> },
        {
            name: "Bank Details", tab: "bankDetails", setTab: toggleTab, data: <div className='p-3 card'> <CommonTable headers={bankDetailsHeaderData} data={bankDetailsTableData} /> </div>
        },
        adminDetail?.role === "superAdmin" && {
            name: "Rate", tab: "rate", setTab: toggleTab, data:
                <div className="card">
                    <div className="card-header" style={{ backgroundColor: "var(--color-card-bg)" }}>
                        Rate
                    </div>
                    <div className="card-body" >
                        <div className='p-5'>
                            <form onSubmit={rateFormik.handleSubmit}>
                                <div className="form-group row row-cols-4">
                                    <div className='d-flex gap-3'>

                                        <label htmlFor='commissionFee' className=" col-form-label">Commission</label>
                                        <div className="">
                                            <input type="text" className="form-control" id='commissionFee' name='commissionFee' placeholder="0" onChange={rateFormik.handleChange} onBlur={rateFormik.handleBlur} value={rateFormik.values.commissionFee} />
                                            {rateFormik.touched?.commissionFee && rateFormik.errors?.commissionFee ? (<div className='req-error'>{rateFormik?.errors?.commissionFee}</div>) : null}
                                        </div>
                                    </div>
                                    <div className='d-flex gap-3'>

                                        <label htmlFor='discount' className=" col-form-label">Discount</label>
                                        <div className="">
                                            <input type="text" className="form-control" id='discount' placeholder="0" name='discount' onChange={rateFormik.handleChange} onBlur={rateFormik.handleBlur} value={rateFormik.values.discount}/>
                                            {rateFormik.touched?.discount && rateFormik.errors?.discount ? (<div className='req-error'>{rateFormik?.errors?.discount}</div>) : null}
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end"  >
                                        <button type="submit" className="btn btn-sm btn-primary" disabled={rateLoader}>Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
        },
        { name: "Review", tab: "review", setTab: toggleTab, data: <div className="card row" ><PartnerReviewTable id={params?.id}/></div> },

    ]

    



    return (
        <div className="main-content">
            <div className="container-fluid">

                {loader ? (
                    <div className="text-center">
                        <Spinwheel />
                    </div>
                ) : (
                    <>
                        <div className="row align-items-end">
                            <div className="col-auto">
                                <div className="avatar avatar-xxl header-avatar-top mt-3">
                                    <img src={rentalVendorDetails?.profileImage ? `${S3_URL}/${rentalVendorDetails?.profileImage}` : "https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg"} alt="profile" className="avatar-img rounded-circle border border-4 border-body" />
                                </div>
                            </div>
                            <div className="col mb-3 ms-n3 ms-md-n2">
                                <h1 className="header-title">
                                    {capitalizeWords(rentalVendorDetails.name)}
                                </h1>
                            </div>
                            <div className="col-12 col-md-auto mt-2 mt-md-0 mb-md-3">
                                {(rentalVendorDetails.vendorStatus === "pending") ? <><button type="button" className="btn btn-outline-primary me-2" data-bs-toggle="modal"
                                    data-bs-target={`#confirmationModal`}
                                    onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "approved", userId: id })) }}>Approve</button>
                                    <button type="button" className="btn btn-outline-secondary" data-bs-toggle="modal"
                                        data-bs-target={`#confirmationModal`}
                                        onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "rejected", userId: id })) }}>Reject</button></> :
                                    <div className={`badge fs-4  ${rentalVendorDetails.vendorStatus === "approved" ? "bg-primary-soft" : "bg-secondary-soft"}`}>{capitalizeWords(rentalVendorDetails.vendorStatus)}</div>
                                }
                            </div>
                        </div>

                        <div className='d-flex justify-content-between'>
                            <ul className="nav nav-tabs">
                                {
                                    tabData.map((ele, index) => (
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === ele.tab ? 'active' : ''}`}
                                                onClick={() => ele.setTab(ele.tab)}
                                            >
                                                {ele.name}
                                            </button>
                                        </li>
                                    ))
                                }
                            </ul>
                            <div>
                            </div>
                        </div>

                        {
                            tabData.map((ele) => (
                                activeTab === ele.tab ? ele.data : null
                            ))
                        }
                    </>
                )}

                <div className="offcanvas offcanvas-end" style={{ width: "45%" }} tabIndex="-1" id="offcanvasRightCites" aria-labelledby="offcanvasRightLabel">
                    <div className="offcanvas-header">
                        <h1 id="offcanvasRightLabel">Documents</h1>
                        <button type="button" className="btn-close text-reset" id="offcanvasRightcoutry" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>
                    <div className="offcanvas-body">
                        <div className="card">
                            <div className="card-body">
                                <div className="row  ">
                                    <div className="mt-3 table-responsive  " style={{ overflowX: "inherit" }}>
                                        <table className="table table-md table-hover card-table">
                                            <thead>
                                                <tr>
                                                    <th> <span className="list-sort text-muted">Type</span></th>
                                                    <th className='text-center'> <span className="list-sort text-muted">File</span></th>
                                                    <th className='text-center'> <span className="list-sort text-muted">Valid Upto</span></th>
                                                    <th className='text-center'> <span className="list-sort text-muted">Status</span></th>
                                                    <th className='text-center'> <span className="list-sort text-muted">Action</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <DocumentDisplay
                                                    title="Vehicle Inssurance"
                                                    document={selectVehicle?.vehicleInsurance}
                                                    setSelectedImg={setSelectedImg}
                                                    status={selectVehicle?.vehicleInsuranceApprovalStatus}
                                                    keyName={"vehicleInsuranceApprovalStatus"}
                                                    validUpto={selectVehicle?.insuranceCertificateValidUpto}
                                                />
                                                <DocumentDisplay
                                                    title="Vehicle Certificate"
                                                    document={selectVehicle?.vehicleCertificate}
                                                    setSelectedImg={setSelectedImg}
                                                    status={selectVehicle?.vehicleCertificateApprovalStatus}
                                                    keyName={"vehicleCertificateApprovalStatus"}
                                                    validUpto={selectVehicle?.vehicleCertificateValidUpto}
                                                />
                                                <DocumentDisplay
                                                    title="Vehicle Image"
                                                    document={selectVehicle?.vehicleImage}
                                                    setSelectedImg={setSelectedImg}
                                                    status={selectVehicle?.vehicleImageApprovalStatus}
                                                    keyName={"vehicleImageApprovalStatus"}
                                                />
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <ConfirmationModal
                    handleConfirm={handleChangeStatus}
                    confirmStatus={confirmStatus}
                />
                <ImageViewModal imgUrl={selectedImg} modalId={"imageViewModal"} />
                <button id="confirmationModal2Btn" className='d-none' data-bs-toggle="modal" data-bs-target={`#${confirmationModalId2}`}></button>
                <ConfirmationModal modalId={confirmationModalId2} message={<>The document is already expired!<br /> Do you still want to continue??</>} handleConfirm={() => handleChangeDocumentStatus("approved", keyNameForUpdate)} title={"Warning!"} confirmStatus={""} />
                <AddOrUpdateDetails formik={driverDetailsFormik} dataFormat={detailsFields[activeTab]?.format} detailsFor={detailsType?.type} addLoader={detailsType?.loading} modalId={driverBankModal2} />
            </div>
        </div>

    );
};

export default RentalVendorDetails;
